<app-base-layout [showFooter]="false" [darkMode]="true" [showHeader]="false" class="loading-page">
  <div class="loading-page-content">
    <app-loading class="loading-page-content-animation"></app-loading>
    <ng-template [ngIf]="isLoading">
      <p>Processando informações...</p>
      <p>(pode levar alguns instantes)</p>
    </ng-template>
    <ng-template [ngIf]="isProcessing">
      <p>Enviando seus dados...</p>
    </ng-template>
  </div>
</app-base-layout>
